export function isLeftMouseClick(event) {
  if ("which" in event)  // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
    return event.which == 1;
  else if ("button" in event)  // IE, Opera
    return event.button == 0;
  return false;
}

export function addClickEventListener(anchor, action) {
  anchor.addEventListener('click', function(event) {
    event.stopPropagation();
    event.preventDefault();

    if (isLeftMouseClick(event)) action(event);
  });
  anchor.addEventListener('touchstart', function(event) {
    event.stopPropagation();
    event.preventDefault();

    action(event);
  });
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/event_helper.js